import i18n from "i18n";

const getAlarmType = (state) => {
    switch (state) {
        case "THEFT":
            return i18n.t("theft");
        case "ATTEMPTED_THEFT":
            return i18n.t("attempted.theft");
        case "FALSE_ALARM":
            return i18n.t("false.alarm");
        case "ALARM":
            return i18n.t("new.alert");
        default:
            return '';
    }
}

export { getAlarmType };
